<template>
  <div class="mt-3">
    <v-toolbar flat color="white" >
      <v-flex xs4 mx-1 v-if="xeroAuth" :key="key">
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingStart"
                  slot="activator"
                  required
                  label="Bill From"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingStart"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1 v-if="xeroAuth" :key="key">
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingEnd"
                  slot="activator"
                  required
                  label="Bill To"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingEnd"></v-date-picker>
              </v-menu>
            </v-flex>
      <v-spacer></v-spacer>
      <v-btn  round color="primary" class="white--text" v-if="authAdmin($store.state.currentRoute)&&billingStart&&billingEnd" @click="getbillingData()">Get Billing Data</v-btn>
      <v-btn v-show="allBilling.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="allBilling"
            :fields="exportFields"
            worksheet="export"
            :name="'Billing_'+new Date().getTime()+'.xls'"
          >Export to Excel</download-excel>
        </v-btn>
      <v-btn v-if="allBilling.length>0" color="light-green" round class="white--text" @click="approveBilling()">Review & Send</v-btn>
      <v-btn round color="primary" class="white--text" v-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
        <!-- <v-btn v-if="selectedOrganisation" round color="primary" class="white--text" @click="approveBilling()">Approve Billing</v-btn> -->
    </v-toolbar>
    <billing :key="key" :billingData="allBilling" :layertwobilling="layerTwoBilling" :runBilling="runBilling"></billing>
    <v-dialog v-model="selectOrgModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Select an Organisation to Bill from:</h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center>
            <v-flex xs4 ma-1>
            <v-select :items="xeroOrganisations" item-text="orgData.name" item-value="orgData.organisationId" label="Organisation" return-object v-model="selectedOrganisation"></v-select>
          </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn v-if="selectedOrganisation" round color="primary" class="white--text" @click="prepInvoiceData()">Done</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="billingModal" persistent width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Invoice Settings</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat v-if="!sendingInvoices&&billingItem.invoiceStatus&&billingItem.lineAmountType&&billingItem.taxRate&&billingItem.dueDate&&billingItem.reference&&billingItem.recurringDescription&&billingItem.onceOffDescription&&billingItem.onceOffAccountCode&&billingItem.recurringAccountCode" @click="sendInvoices()">Approve</v-btn>
          <v-btn flat color="white" v-if="sendingInvoices" disabled>Sending Invoices <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
          <v-btn flat color="white" @click="billingModal=false, billingItem={}, selectedBilling=[]">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs4 mx-1>
              <v-select label="Invoice Status" :items="invoiceStatuses" v-model="billingItem.invoiceStatus"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Invoice reference" v-model="billingItem.reference"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-select label="Amount Tax Type" :items="lineAmountTypes" v-model="billingItem.lineAmountType"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-select label="Tax Rate" :items="xeroTaxRates" item-text="name" item-value="taxType" v-model="billingItem.taxRate"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete :items="xeroAccounts" label="Xero Account: Once-off Sales" item-text="name" item-value="code" v-model="billingItem.onceOffAccountCode"></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Once Off Sales Item Description" v-model="billingItem.onceOffDescription"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete :items="xeroAccounts" label="Xero Account: Recurring Sales" item-text="name" item-value="code" v-model="billingItem.recurringAccountCode"></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Recurring Sales Description" v-model="billingItem.recurringDescription"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
               <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingItem.dueDate"
                  slot="activator"
                  required
                  label="Due Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingItem.dueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-checkbox v-model="billingItem.sendEmail" label="Email Invoice(s)"></v-checkbox>
            </v-flex>
            
            <v-flex xs10 mx-1>
              <h3 class="grey--text">Invoices Breakdown:</h3>
            </v-flex>
            <v-flex xs8 mx-1 v-for="invoice in invoiceData" :key="invoice.organisationId">
              <v-card color="white" hover class="text-xs-left my-1">
                   <v-layout justify-center align-center wrap>
                <v-flex xs9 ma-1 class="text-xs-right">
                  <!-- <v-flex class="text-xs-left" mx-1>
                    
                  </v-flex> -->
                  <v-layout align-center wrap>
                    <h3 class="title grey--text text-xs-left" mx-1>
                      {{invoice.name}}
                      </h3>
                  <v-spacer></v-spacer>
                      <v-chip v-if="invoice.xeroContactId" color="light-green" class="white--text"><v-icon color="white">check_circle_outline</v-icon>Linked</v-chip><v-chip v-else color="orange" class="white--text"><v-icon color="white">warning</v-icon>Not Linked</v-chip>

                  </v-layout>
                  
                  <!-- <v-chip v-if="billingItem.invoiceStatus" color="blue" class="white--text">{{billingItem.invoiceStatus}}</v-chip> -->
                </v-flex>
                <v-flex xs12 mx-1 v-for="item in invoice.lineItems" :key="item.name">
                  <v-layout justify-center align-center wrap>
                    <v-flex xs4 mx-1>
                      <h4 class="grey--text font-weight-light" v-if="item.name=='Recurring'&&!billingItem.recurringAccountCode">{{item.name}} Sales</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Recurring'&&billingItem.recurringAccountCode">Account Code: {{billingItem.recurringAccountCode}} (Recurring sales)</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Once-Off'&&!billingItem.onceOffAccountCode">{{item.name}} Sales</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Once-Off'&&billingItem.onceOffAccountCode">Account Code: {{billingItem.onceOffAccountCode}} (Once-Off sales)</h4>
                    </v-flex>
                    <v-flex xs7 class="text-xs-right">
                      <h4 class="grey--text"><b>{{item.amount | currency}}</b> excl. VAT</h4>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex class="text-xs-right" v-if="invoice.lineItems.length>1">
                <h3 class="grey--text">Total: {{invoice.lineItems.reduce((a, b) => +a + +b.amount, 0) | currency}} excl. VAT</h3>

                </v-flex>
              </v-layout>
              </v-card>
             

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="invoiceSuccessModal" persistent width="750px">
      <v-card color="white" flat>
        <v-toolbar flat color="light-green">
          <h3 class="title white--text">
            Successfully created the following invoices:
          </h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs8 mx-1 v-for="invoice in successfulInvoices" :key="invoice.invoiceID">
              <v-layout justify-center align-center>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.invoiceNumber}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.contact.name}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.total | currency}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <v-chip v-if="invoice.status == 'DRAFT'" color="blue" class="white--text">DRAFT</v-chip>
                  <v-chip v-else color="light-green" class="white--text">{{invoice.status}}</v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn round color="light-green" class="white--text" @click="invoiceSuccessModal=false, successfulInvoices=[]">Done</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import Billing from "@/components/Billing.vue";
export default {
  components: {
    billing: Billing
  },
  data() {
    return {
      billingDetails: false,
      exportFields: {
        id: "id",
        node: "location.locationNetwork.locationNode.name",
        network: "location.locationNetwork.name",
        subNetwork: {
          callback: value => {
            if(value.location.locationNetworkSubComplexId !== null){
            return value.location.locationNetworkSubComplex.subComplexName;
            } else {
              return value.location.subComplexName
            }
          }
        },
        unit: "location.locationDescription",
        // {
        //   callback: value => {
        //     if (value.location.locationNetworkSubComplexId !== null) {
        //       return (
        //         value.location.unitNo +
        //         " " +
        //         value.location.locationNetworkSubComplex.subComplexName
        //       );
        //     } else {
        //       return value.location.unitNo;
        //     }
        //   }
        // },
        ispName: "packagesIsp.customerOrganisation.name",
        pppoeUsername: "pppoeUsername",
        fnoPackage: "packagesIsp.packagesFno.packageCode",
        downloadMbps: "packagesIsp.packagesFno.speedProfile.downloadMbps",
        initialActivation: {
          callback: value => {
            return this.formatDate(value.initialActivation);
          }
        },
        ispActivation: {
          callback: value => {
            return this.formatDate(value.ispActivationDate);
          }
        },
        ispDeactivation: {
          callback: value => {
            return this.formatDate(value.ispDeactivationDate);
          }
        },
        fnoActivation: {
          callback: value => {
            return this.formatDate(value.fnoActivationDate);
          }
        },
        fnoDeactivation: {
          callback: value => {
            return this.formatDate(value.fnoDeactivationDate);
          }
        },
        fnoPackagePrice: {
          callback: value => {
            if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.residentialLineRentalValue
              );
            } else if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.businessLineRentalValue
              );
            } else {
              return value.packagesIsp.packagesFno.packageBasePrice;
            }
          }
        },
        billedFrom:  {
          callback: value => {
            return this.formatDate(value.startDate);
          }
        },
        billedTo: {
          callback: value => {
            return this.formatDate(value.endDate);
          }
        },
        "Data Activation Fee": 'onceOff',
        "VAS Billed": 'prorata'
          
        
      },
      allBilling: [],
      billingSummary: [],
      billingDate: new Date(),
      billingStart: null,
      billingEnd: null,
      billingItem: {},
      billingModal : false,
      startDay: null,
      endDay: null,
      startDate: null,
      endDate: null,
      daysInCurrentMonth: null,
      billedDays: 0,
      invoiceSuccessModal: false,
      key: 1,
      organisations: [],
      invoiceData: [],
      layerTwoBilling: [],
      runBilling: false,
      selectedOrganisation: null,
      selectOrgModal: false,
      sendingInvoices: false,
      successfulInvoices: [],
      xeroAccounts: [],
      xeroAccountContacts: [],
      xeroAuth: null,
      xeroContacts: [],
      xeroOrganisations: [],
      xeroUrl: null,
      xeroTaxRates: [],
      invoiceStatuses: ['DRAFT', 'SUBMITTED', 'AUTHORISED'],
      lineAmountTypes: ['Exclusive', 'Inclusive', 'NoTax'],
    };
  },
  watch: {
    
    async setDate(value) {}
  },
  async created() {
        this.initialize();
  },
  methods: {
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    initialize(){
      this.getXeroLoginUrl()
    },
    async getbillingData(){
      // (this.startDay = new Date(this.setDate)),
          this.setDate = this.billingDate;
          let initialDate = new Date(this.setDate);
          let selectedDate = new Date(
            initialDate.getFullYear(),
            initialDate.getMonth(),
            25
          );

          // this.startDay = new Date(
          //   selectedDate.getFullYear(),
          //   selectedDate.getMonth() - 1,
          //   26
          // ),
          this.startDay = new Date(this.billingStart)
          this.startDay.setHours(0,0,0,0)

            this.endDay = new Date(this.billingEnd)

            // this.endDay = new Date(
            //   this.startDay.getFullYear(),
            //   this.startDay.getMonth() + 1,
            //   25
            // );
          this.endDay.setHours(0,0,0,0)


          let date = new Date(
            this.startDay.getFullYear(),
            this.startDay.getMonth(),
            0
          );
          this.layerTwoBilling = [];
          let start = this.startDay;
          let end = this.endDay;
          // for(let i = 0;i<this.organisations.length;i++){
          //   let bill = this.organisations[i].layerTwo.filter(function(el){
          //     return new Date(el.bill_dateto)>new Date(start)&&
          //           new Date(el.bill_dateto)<new Date(end)
          //   })
          //   if(bill.length>0){
          //     await this.layerTwoBilling.push({organisationId: this.organisations[i].id, xeroContactId: this.organisations[i].xeroContactId, layerTwoUsage: (Math.round(bill[0].rate_95th/10000)/100), layerTwoRate: this.organisations[i].layerTwoRate, from: bill[0].bill_datefrom, to: bill[0].bill_dateto})
          //   }
          // }
          if(this.$store.state.currentOrg.org.oneDevicePolicy){
            await Api()
            .get("/serviceAccounts/billing/oneDevice", {
              params: {
                billingStart: this.billingStart,
                billingEnd: this.billingEnd
              }
            })
            .then(async response => {
              this.allBilling = response.data;
            })
          } else {
            await Api()
            .get("/serviceAccounts/billing", {
              params: {
                billingStart: this.billingStart,
                billingEnd: this.billingEnd
              }
            })
            .then(async response => {
              this.allBilling = response.data;
            })
          }
          // await Api()
          //   .get("/serviceAccounts/billing", {
          //     params: {
          //       billingDate: this.$route.query.billingDate
          //     }
          //   })
          //   .then(async response => {
              for (let i = 0; i < this.allBilling.length; i++) {
                //   Recurring Billing
                this.allBilling[i].prorata = await this.calcuateRecurringBills(
                  this.allBilling[i]
                );
                this.allBilling[i].layerTwoProrata = this.allBilling[i].packagesIsp.packagesFno.layerTwoPortion*(this.allBilling[i].prorata/this.allBilling[i].packagesIsp.packagesFno.packageBasePrice)
                // Once Off Activations
                if (
                  new Date(this.allBilling[i].initialActivation) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].initialActivation) >=
                    new Date(this.startDay) &&
                  this.allBilling[i].isChange === false
                ) {
                  this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                } else if (
                  new Date(this.allBilling[i].initialActivation) ===
                    new Date(this.endDay) ||
                  new Date(this.allBilling[i].initialActivation) ===
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                } else {
                  this.allBilling[i].onceOff = 0;
                }
                // Start Date
                if (
                  new Date(this.allBilling[i].initialActivation) >=
                  new Date(this.startDay)
                ) {
                  this.allBilling[i].startDate = this.allBilling[
                    i
                  ].initialActivation;
                } else {
                  this.allBilling[i].startDate = this.startDay;
                }
                // End Date
                if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate === null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate === null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].ispDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].ispDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].ispDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].ispDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else {
                  this.allBilling[i].endDate = this.endDay;
                }
              }
            // });
          this.key += 1;

        // }
    },
     getXeroLoginUrl(){
      // debugger
      Api().get('/xero/authenticate').then(response=>{
        if(response.data.url){
        this.xeroUrl = response.data.url
        if(this.$route.query.code){
          this.getXeroTokens(this.xeroUrl)
      }} else if(response.data.tokenSet){
        this.xeroAuth = response.data.tokenSet
        this.getXeroOrganisations()
      }
      })
    },
    getXeroTokens(){
      Api().get('/xero/callback', {
        params:  this.$route.query
      }).then(response=>{
        if(response.data.tokenSet){
          // console.log(response.data)
          this.xeroAuth = response.data.tokenSet
          // console.log(this.xeroAuth)
          this.key+=1
          this.getXeroOrganisations()
        }
      })
    },
    getXeroTaxRates(tenantId){
      Api().get('/xero/taxRates/'+tenantId).then(response=>{
        if(response.data.body.taxRates){
          this.xeroTaxRates = response.data.body.taxRates
        }
      })
    },
    getXeroContacts(tenantId){
      Api().get('/xero/contacts').then(response=>{
        if(response.data.body.contacts){
        this.xeroContacts = response.data.body.contacts
        }
        
      })
    },
    getXeroAccounts(tenantId){
      Api().get('/xero/accounts/'+tenantId).then(response=>{
        if(response.data.body.accounts){
        this.xeroAccounts = response.data.body.accounts
        }
        
      })
    },
    getXeroOrganisations(){
      Api().get('/xero/getOrganisations').then(response=>{
        this.xeroOrganisations = response.data
        if(this.xeroOrganisations.length>1){
        this.selectOrgModal= true
        } else {
          this.selectedOrganisation = this.xeroOrganisations[0]
          this.prepInvoiceData()
        }
      })
    },
    getLinkedAccounts(tenantId){
      Api().get('/xeroAccountContact').then(response=>{
        this.xeroAccountContacts = response.data
      })
    },
     async prepInvoiceData(){
      await this.getLinkedAccounts()
      await this.getXeroTaxRates(this.selectedOrganisation.tenantId)
      await this.getXeroContacts(this.selectedOrganisation.tenantId)
      this.getXeroAccounts(this.selectedOrganisation.tenantId)
      this.selectOrgModal = false
    },
    async calcuateRecurringBills(item) {
      var one_day = 1000 * 60 * 60 * 24
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.initialActivation) >= new Date(this.startDay)) {
        this.startDate = new Date(item.initialActivation);
      } else {
        this.startDate = new Date(this.startDay);
      }
      if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate === null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      } else if (
        item.fnoDeactivationDate === null &&
        item.ispDeactivationDate !== null &&
        new Date(item.ispDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.ispDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.ispDeactivationDate);
      } else if (
        item.fnoDeactivationDate !== null &&
        item.ispDeactivationDate !== null
      ) {
        if (
          new Date(item.fnoDeactivationDate) > new Date(this.endDay) &&
          new Date(item.ispDeactivationDate) > new Date(this.endDay)
        ) {
          this.endDate = new Date(this.endDay);
        } else if (
          new Date(item.fnoDeactivationDate) >=
          new Date(item.ispDeactivationDate)
        ) {
          this.endDate = new Date(item.fnoDeactivationDate);
        } else {
          this.endDate = new Date(item.ispDeactivationDate);
        }
      }
      let setDate = new Date(this.setDate);
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / one_day
      )+1;
      if(this.endDay.getMonth() != 1){
        if(this.daysInCurrentMonth<30){
        this.daysInCurrentMonth = 30
      }
      }
      
      // this.startDate = new Date(this.startDate);
      this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())
      this.startDate.setHours(0,0,0,0);
      this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())
      this.endDate.setHours(0,0,0,0);
      let billedAmount = item.packagesIsp.packagesFno.packageBasePrice;
      
      this.billedDays = Math.round(
        (Math.abs(this.endDate.getTime() - this.startDate.getTime()) / one_day)
      )+1;
      if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Residential"
      ) {
        billedAmount =
          billedAmount -
          item.location.locationNetwork.residentialLineRentalValue;
      } else if (
        item.location.locationNetwork.lineRentalIncluded &&
        item.packagesIsp.packagesFno.packagesFnoCat.packageCatType ===
          "Business"
      ) {
        billedAmount =
          billedAmount - item.location.locationNetwork.businessLineRentalValue;
      }
      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    },
    async approveBilling(){
      // this.invoiceData
      this.billingItem = {
        sendEmail: false
      }
      let allBilling = this.allBilling
      let organisations = [
            ...new Set(
              this.allBilling.map(
                item => item.packagesIsp.customerOrganisationId
              )
            )
          ];
          this.invoiceData = []
          for(let x=0; x< organisations.length;x++){
             let find = await this.allBilling.find(y=>y.customerOrganisationId === organisations[x])
             let xero = await this.xeroAccountContacts.find(z=>z.customerOrganisationId === organisations[x])
             let xeroContactName = null
             let xeroContactId = null
             if(xero){
               xeroContactName=xero.xeroContactName
               xeroContactId = xero.xeroContactId
             }
            let obj = {
              organisationId: organisations[x],
              name: find.packagesIsp.customerOrganisation.name,
              xeroContactName: xeroContactName,
              xeroContactId: xeroContactId,
              lineItems: [],
              accounts: await this.allBilling.filter(a=>
              a.customerOrganisationId==organisations[x]
            )
            }
            let onceOffData = await this.allBilling.filter(z=>
              z.onceOff>0&&z.customerOrganisationId==organisations[x]
            )
            if(onceOffData.length>0){
              await obj.lineItems.push({type: 'Once-Off', quantity: 1, amount: onceOffData.reduce((a, b) => +a + +b.onceOff, 0)})
            }
            let recurringData = await this.allBilling.filter(z=>
              z.packagesIsp.customerOrganisationId == organisations[x]
            )
            if(recurringData.length>0){
              await obj.lineItems.push({name: 'Recurring', quantity: 1, amount: recurringData.reduce((a, b) => +a + +b.prorata, 0)})
            }
            await this.invoiceData.push(obj)
          }
          // await organisations.forEach(async x=>{
           
          // })
          console.log(this.invoiceData)
      this.billingModal=true
    },
    async sendInvoices(){
      this.sendingInvoices = true
      console.log(this.billingItem)
      let billableOrgs = this.invoiceData.filter(x=>x.xeroContactId)
      let invoice = []
      await billableOrgs.forEach(async x=>{
        let obj = {
  type: "ACCREC",
  contact: { 
    contactID: x.xeroContactId 
  },
  date: new Date().toISOString()
              .substr(0, 10),
  dueDate: this.billingItem.dueDate,
  dateString: new Date().toISOString()
              .substr(0, 10),
  dueDateString: this.billingItem.dueDate.toString(),
  lineAmountTypes: this.billingItem.lineAmountType,
  reference: this.billingItem.reference,
  status: this.billingItem.invoiceStatus,
      sendEmail: this.billingItem.sendEmail,
      organisationId: x.organisationId,
  lineItems: []
}

for (let y=0; y<x.lineItems.length;y++){
  if(x.lineItems[y].name=='Recurring'){
    obj.lineItems.push({
      description: this.billingItem.recurringDescription,
      quantity: x.lineItems[y].quantity,
      unitAmount: x.lineItems[y].amount,
      accountCode: this.billingItem.recurringAccountCode,
      taxType: this.billingItem.taxRate
    })
  } else if(x.lineItems[y].name=='Once-Off') {
obj.lineItems.push({
      description: this.billingItem.onceOffDescription,
      quantity: x.lineItems[y].quantity,
      unitAmount: x.lineItems[y].amount,
      accountCode: this.billingItem.onceOffAccountCode,
      taxType: this.billingItem.taxRate
    })
  }
}
invoice.push(obj)
      })
      // console.log(invoice)
      let sendData = await this.allBilling.map(x=>({
        serviceAccountId: x.id,
        ispId: x.packagesIsp.customerOrganisationId,
        ispName: x.packagesIsp.customerOrganisation.name,
        node: x.location.locationNetwork.locationNode.name,
        network: x.location.locationNetwork.name,
        unit: x.location.locationDescription,
        pppoeUsername: x.pppoeUsername,
        fnoPackage: x.packagesIsp.packagesFno.packageCode,
        fnoPackagePrice: x.packagesIsp.packagesFno.packageBasePrice,
        downloadMbps: x.packagesIsp.packagesFno.speedProfile.downloadMbps,
        uploadMbps: x.packagesIsp.packagesFno.speedProfile.uploadMbps,
        initialActivation:  this.formatDate(x.initialActivation),
        fnoActivation: this.formatDate(x.fnoActivationDate),
        fnoDeactivation: this.formatDate(x.fnoDeactivationDate),
        billedFrom: this.formatDate(x.startDate),
        billedTo: this.formatDate(x.endDate),
        setupFeeCharged: x.onceOff,
        monthlyFeeCharged: x.prorata
        }))
        console.log(sendData)
      await Api().post('/xero/invoices/'+this.selectedOrganisation.tenantId, {billingData: sendData, invoices: invoice})
      .then(response=>{
        console.log(response.data)
        if(response.data.response.statusCode==200){
          this.successfulInvoices = response.data.body.invoices
          this.sendingInvoices = false
            this.invoiceSuccessModal=true 
        }

        this.billingItem={}
        this.invoiceData = []
        this.billingModal = false
        
      })
    }
  }
};
</script>
